import React, { Suspense, useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { isMobileDevice } from '../utils/isMobileDevice';

const LazySection = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '120px 0px',
    threshold: 0,
  });

  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  if (!isMobile) {
    return children;
  }

  return (
    <div ref={ref}>
      {inView ? <Suspense fallback={null}>{children}</Suspense> : null}
    </div>
  );
};

export default LazySection;
